<template>
  <div class="modal" :class="{'is-active': display}" v-cloak>
    <div class="modal-background" @click="closeModal()"></div>
    <div class="modal-card is-not-clipped preview-size">
      <header class="modal-card-head">
        <h5 class="modal-card-title title is-5 is-fullwidth-mobile">
          {{ title }}
        </h5>
        <button class="delete" aria-label="close" @click="$emit('close')"></button>
      </header>

      <section class="modal-card-body overflow-inherit">
        <flashes :alerts="alerts.data" v-if="alerts && alerts.action === 'modal'"></flashes>
		  <div class="is-fullwidth mt-6 has-text-centered is-loading" v-show="loading">

		  </div>
		  <iframe :src="url" style="width: 100%; height: 100%" @load="load" ></iframe>
      </section>
    </div>
  </div>
</template>

<script>
export default {
	props: [
		'title',
		'alerts',
		'display',
		'url'
	],
	data ()
	{
		return {
			loading: true,
		}
	},
	watch: {
		url(newVal) {
			this.loading = true;
		},
	},
	methods: {
		load() {
			if (this.url)
			{
				this.loading = false;
			}
		},
	},
}
</script>

<style scoped>
  .preview-size {
    width: 90%;
    height: 90%;
  }

  .overflow-inherit
  {
    overflow: inherit !important;
  }
</style>
